export default "__VITE_ASSET__FdoArHkn__"